import React, { memo, useState } from 'react'
import Styles from '../../Css/View360/View360.module.css'
import { downArrowHeadSvg } from './common/svgs';
import useMobile from '../../utils/threeD/useMobile';

const BeforeContainer = ({urls }) => {
    const videoUrl1 = urls?.[0];
    const videoUrl2 = urls?.[1];
    const [showInputVideo, setShowInputVideo] = useState(true);
    const {isMobile, isMobilePortrait} = useMobile();
    return (
        <div className={`text-left transition-all`}>
            <div className='text-xs hidden md:block text-left p-1 font-medium mb-[5px]'>Input</div>
            <div className='text-black-60 flex items-center gap-1 text-sm leading-[20px] font-medium md:hidden' onClick={()=>setShowInputVideo(prev=>!prev)}>View Input Video<span className={`transition-all ${showInputVideo? "":"-rotate-90"}`}>{downArrowHeadSvg("20", "20", "none", "rgba(0, 0, 0, 0.6)")}</span></div>
            {<div className={`flex flex-col gap-4 h-full md:h-auto ${showInputVideo? "": "hidden"}`}>
                <div className='w-full h-full flex flex-col justify-center items-center'>
                    {videoUrl1 && 
                    
                    <div className='w-full rounded-xl '>   
                        <div className='md:hidden text-xs text-left p-1 font-medium mb-[5px]'>Input - Mid 90°</div>
                        <div className='hidden md:block px-[14px] py-[10px] bg-[#919EAB1A] text-sm leading-[22px] font-medium text-black-60'>Mid 90° Shoot</div>
                        <video 
                            controls
                            muted
                            playsInline
                            loop
                            className={`w-full ${ isMobilePortrait? 'h-[22vh]': ' h-[40vh] md:w-full md:h-full' } object-cover rounded-xl rounded-t-none`}
                        >
                        <source src={videoUrl1} type="video/mp4" />
                        </video>
                    </div>
                    
                    }
                    {videoUrl2 &&
                      <div className='w-full  rounded-xl  mt-2'>   
                        <div className='md:hidden text-xs text-left p-1 font-medium mb-[5px]'>Input - Top 45°</div>
                        <div className='hidden md:block px-[14px] py-[10px] bg-[#919EAB1A] text-sm leading-[22px] font-medium text-black-60'>Top 45° Shoot</div>
                        <video 
                            controls
                            muted
                            playsInline
                            loop
                            className={`w-full ${ isMobilePortrait? 'h-[22vh]': ' h-[40vh] md:w-full md:h-full' } object-cover rounded-xl rounded-t-none`}
                        >
                            <source src={videoUrl2} type="video/mp4" />
                            </video>
                    </div>
                    }
                </div>
            </div>}
        </div>
    )
}

export default memo(BeforeContainer)
